export default __webpack_public_path__ + "static/media/Group 8137.868d3e26.png";